<div class="page">
    <div class="page-header">
        <div class="header-left">
            <mat-icon class="back-icon" routerLink="/doctors">arrow_back</mat-icon>
            <h3>{{ doctor.name }} adatainak módosítása</h3>
        </div>
    </div>

    <div class="form-section">
        <form novalidate [formGroup]="doctorForm!">
            <div class="form-row">
                <label for="name">Orvos neve <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="name" id="name" type="text" required />
                </div>
            </div>

            <div class="form-row">
                <label for="reservationLink">Orvos foglalási linkje <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="reservationLink" id="reservationLink" type="text" required />
                </div>
            </div>

            <div class="form-row">
                <label for="routerLink">Orvos url-e <span class="required">*</span></label>
                <div class="form-input">
                    <span class="hint">Pl.: dr_balo_timea</span>
                    <input formControlName="routerLink" id="routerLink" type="text" required />
                </div>
            </div>

            <div class="form-row full-width">
                <label>Orvos bemutatkozó szövege</label>
                <pf-fileexplorer />
                <div class="form-input">
                    <app-tinymcehtmleditor id="html" ngDefaultControl [html]="doctor.introduction!"
                        [htmlForm]="htmlForm" />
                </div>
            </div>

            <div class="form-row">
                <label>Kép (.jpg vagy .png)</label>
                <div class="form-input file-row">
                    <button type="button" class="btn btn-file" onclick="document.getElementById('fileCover').click()">
                        Kép kiválasztása
                    </button>
                    @if (updateCoverFile) {
                    <span>{{ fileCover?.name }}</span>
                    } @else {
                    <a href="{{ doctor.image }}" target="_blank">Jelenlegi borítókép</a>
                    }
                    <mat-icon class="delete-icon" (click)="clearSelectedCoverFile()">delete_forever</mat-icon>
                    <input #fileCoverInput id="fileCover" type="file" hidden (change)="onChange($event)" />
                </div>
            </div>
        </form>
    </div>

    <div class="form-section">
        <h4 class="section-title">Jelenlegi munkakörök</h4>
        <div class="form-row">
            <div class="form-input checkbox-wrap">
                @for (doctorSpeciality of doctor.doctorSpecialityList; track doctorSpeciality) {
                <div class="job-title-item">
                    <input type="text" disabled [placeholder]="doctorSpeciality.speciality?.jobTitle" />
                    <mat-icon class="delete-icon"
                        (click)="openDeleteDoctorSpecialityDialog(doctor.name!, doctorSpeciality.speciality?.jobTitle!, doctorSpeciality.id!)">
                        delete_forever
                    </mat-icon>
                </div>
                }
            </div>
        </div>

        <h4 class="section-title">Munkakör hozzáadása</h4>
        <mat-icon class="add-icon" routerLink="/addspeciality">add_circle</mat-icon>
        <div class="form-row">
            <div class="form-input checkbox-wrap">
                @for (speciality of specialityWithCheckedList; track speciality) {
                <section>
                    <mat-checkbox (click)="changeJobTitle(speciality)">
                        {{ speciality.speciality?.jobTitle }}
                    </mat-checkbox>
                </section>
                }
            </div>
        </div>
    </div>

    <div class="form-section">
        <h4 class="section-title">Konzultációs idő módosítása</h4>
        <mat-icon class="add-icon" (click)="addConsultationHour()">add_circle</mat-icon>

        <form novalidate [formGroup]="consultingHourForm!">
            <div formArrayName="items">
                @for (item of items.controls; track item; let i = $index) {
                <div class="consulting-row"
                    [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }" [formGroupName]="i">
                    <div class="form-row no-border">
                        <label>Konzultáció napja</label>
                        <div class="form-input">
                            <input formControlName="day" type="text" required />
                        </div>
                    </div>
                    <div class="form-row no-border">
                        <label>Konzultáció kezdete</label>
                        <div class="form-input">
                            <input formControlName="startTime" type="time" />
                        </div>
                    </div>
                    <div class="form-row no-border">
                        <label>Konzultáció vége</label>
                        <div class="form-input">
                            <input formControlName="endTime" type="time" />
                        </div>
                        <mat-icon class="delete-icon"
                            (click)="openDeleteConsultingDialog(items.at(i).get('id')?.value)">
                            delete_forever
                        </mat-icon>
                    </div>
                </div>
                }
            </div>
        </form>

        <h4 class="section-title">SEO</h4>
        <pf-meta [isUpdate]="true" [urlPrefix]="doctorUrlPrefix" />
    </div>

    @if (formsReady) {
    <div class="submit-row">
        <button class="btn btn-submit" [disabled]="!isFormValid" (click)="updateDoctor()">
            ORVOS MÓDOSÍTÁSA
        </button>
    </div>
    }
</div>